export default __webpack_public_path__ + "static/media/fraud_protection.65dc9e85.jpg";